import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { PointsTransactionSchema } from "@redotech/redo-model/outbound-labels/points";
import { PaginationCursorSchema } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getPointsTransactions = {
  name: "getPointsTransactions" as const,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number(),
    pageSize: z.number(),
    paginationCursor: PaginationCursorSchema.nullish(),
  }),
  output: z.object({
    transactions: z.array(PointsTransactionSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
  }),
};
